import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PrivacyConsentBanner } from "@/components/privacy/PrivacyConsentBanner";
import { PrivacyPreferencesDialog } from "@/components/privacy/PrivacyPreferencesDialog";
import { usePrivacyConsent } from "@/hooks/usePrivacyConsent";
import { PRIVACY_PREFERENCES_EVENT } from "@/services/privacy/privacyConsentService";

export function PrivacyConsentRoot() {
  const location = useLocation();
  const { hasAnswered, analyticsEnabled, acceptAnalytics, rejectAnalytics, setAnalyticsEnabled } =
    usePrivacyConsent();
  const [preferencesOpen, setPreferencesOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => setPreferencesOpen(true);
    window.addEventListener(PRIVACY_PREFERENCES_EVENT, onOpen);
    return () => window.removeEventListener(PRIVACY_PREFERENCES_EVENT, onOpen);
  }, []);

  const isEmbed = location.pathname.startsWith("/embed");
  const showBanner = !hasAnswered && !preferencesOpen && !isEmbed;

  return (
    <>
      {showBanner ? (
        <PrivacyConsentBanner
          onAccept={acceptAnalytics}
          onReject={rejectAnalytics}
        />
      ) : null}
      <PrivacyPreferencesDialog
        open={preferencesOpen}
        onOpenChange={setPreferencesOpen}
        analyticsEnabled={analyticsEnabled}
        onAnalyticsChange={setAnalyticsEnabled}
      />
    </>
  );
}
